import { twMerge } from 'tailwind-merge';

import Link from '@/components/Link';
import type { pathnames } from '@/navigation';

type Props = {
  href: keyof typeof pathnames | string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'white' | 'warning' | 'danger' | 'text';
};

export const InternalLink = ({
  href,
  children,
  className,
  size = 'md',
  color = 'primary',
}: Props) => {
  const primaryClasses = 'bg-gray-900 text-white hover:bg-black';
  const secondaryClasses = 'bg-white text-gray-900 hover:bg-gray-100';
  const whiteClasses = 'bg-white text-gray-900 hover:bg-gray-100';
  const warningClasses = 'bg-yellow-500 text-white hover:bg-yellow-600';
  const dangerClasses = 'bg-red-500 text-white hover:bg-red-600';

  let mergedClassNames;
  if (color === 'text') {
    mergedClassNames =
      'font-normal text-gray-500 underline underline-offset-4 outline-none hover:text-gray-700 focus:ring-2 focus:ring-inset focus:ring-brand-500';
  } else {
    mergedClassNames = twMerge(
      'flex border-2 justify-center items-center h-11 rounded-full px-4 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 transform active:scale-[0.98] transition-transform',
      size === 'sm' && 'h-8 px-3 text-xs',
      size === 'lg' && 'h-12 px-5 text-lg',
      color === 'primary' && primaryClasses,
      color === 'secondary' && secondaryClasses,
      color === 'warning' && warningClasses,
      color === 'danger' && dangerClasses,
      color === 'white' && whiteClasses,
      className,
    );
  }

  return (
    <Link href={href} className={mergedClassNames}>
      {children}
    </Link>
  );
};
